import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAuth } from '../context/UserAuth';
import { useDarkMode } from '../context/DarkMode';

export default function Navbar() {
  const navigate = useNavigate();
  const { toggleMode } = useDarkMode();

  const { Logout } = useAuth();
  const { Token, GetUser } = useSelector((state) => state.auth);

  const logoutHandle = () => {
    //? from context
    Logout();

    //!navigate
    navigate('/');
  };

  return (
    <div className='Navbar'>
      <nav className='navbar navbar-expand-lg navbar-dark bg-dark'>
        <div className='container-fluid'>
          <Link className='navbar-brand' to='/'>
            <strong>Redux-Toolkit</strong>
          </Link>
          <button
            className='navbar-toggler'
            type='button'
            data-bs-toggle='collapse'
            data-bs-target='#navbarSupportedContent'
            aria-controls='navbarSupportedContent'
            aria-expanded='false'
            aria-label='Toggle navigation'
          >
            <span className='navbar-toggler-icon'></span>
          </button>
          <div className='collapse navbar-collapse' id='navbarSupportedContent'>
            <ul className='navbar-nav me-auto mb-2 mb-lg-0'>
              <li className='nav-item active'>
                <Link className='nav-link ' aria-current='page' to='/'>
                  <strong>Home</strong>
                </Link>
              </li>
              <>
                <li className='nav-item active'>
                  <Link className='nav-link ' aria-current='page' to={`/rest-api/${GetUser?._id}`}>
                    <strong>Users</strong>
                  </Link>
                </li>
                <li className='nav-item active'>
                  <Link className='nav-link ' aria-current='page' to={`/graphql-api/${GetUser?._id}`}>
                    <strong>Apollo-Graphql</strong>
                  </Link>
                </li>
              </>
              <li className='nav-item active'>
                <Link className='nav-link' aria-current='page' to='/about'>
                  <strong>About</strong>
                </Link>
              </li>
              <li className='nav-item active'>
                <Link className='nav-link' aria-current='page' to='/contact'>
                  <strong>Contact</strong>
                </Link>
              </li>
            </ul>
            <div className='form-check form-switch text-white mx-2 mt-2'>
              <input
                className='form-check-input'
                type='checkbox'
                role='switch'
                id='flexSwitchCheckDefault'
                onClick={toggleMode}
              />
              <label className='form-check-label' htmlFor='flexSwitchCheckDefault'>
                DarkMode
              </label>
            </div>

            {!Token && (
              <>
                <Link to='/login'>
                  <button type='button' className='btn btn-info mx-2 my-1'>
                    <strong>Login</strong>
                  </button>
                </Link>
                <Link to='/signup'>
                  <button type='button' className='btn btn-warning mx-2 my-1'>
                    <strong>Sign-up</strong>
                  </button>
                </Link>
              </>
            )}
            {Token && (
              <button type='button' className='btn btn-danger mx-2 my-1' onClick={logoutHandle}>
                <strong>Logout</strong>
              </button>
            )}
          </div>
        </div>
      </nav>
    </div>
  );
}
